import React, { useEffect, useState } from 'react';
import applicantsService from '../../../../../Services/applicantsService';
import toast from 'react-hot-toast';
import ReviewALLDocument from './ReviewStages/reviewstages';
import { Modal } from 'react-bootstrap';
// import { useNavigate } from 'react-router-dom';
interface ReviewStageProps {
  nin: any;
  setCurrentPage: (page: number) => void;
  currentPage: number;
  validationData?: any;
     finalSubmissionForm: any;
                          finalSubmissionLoad: any;
                          submissionStatus: boolean
                          // manifestInfo: any
                        //   dataB: any
}
export default function ReviewStage (props: ReviewStageProps) {
  const [previewData, setPreviewData] = React.useState<any>(null);
  const [showAttention, setShowAttention] = useState(true)

  const previewPage = async () => {
    try {
      const response = await applicantsService.preview(
        props.nin
      );
      // console.log('Preview Response:', response.data);
      setPreviewData(response.data);
    } catch (error) {
      console.error('Error fetching preview data:', error);
      toast.error('Failed to load preview data. Please try again later.');
    }
  };

  useEffect(() => {
    previewPage();
    setTimeout(() => {
      setShowAttention(false)
    }, 5000)
  }, []);
  const [timeLeft, setTimeLeft] = useState(180);
  useEffect(() => {
    const intervalId = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(intervalId);
          props.finalSubmissionForm();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);
  return (
    <div>
      <section className=' border-0 rounded ' id='review'>
        <div className='bg-white'>
          <div className='section-container'>
            <div className='section-item-container'></div>
            <div className='section-item-container p-1'>
              <h3 className='sub-heading__pinfo'>Review Application</h3>
            </div>
            <div className='section-item-container'></div>
          </div>
          <div className='row m-0 p-0'>
            <div className='col-md-12 offset-md-0  bg-white'>
              {previewData
                ? (
                <>
                  <div className='d-flex justify-content-center'>
                    <img
                      src={previewData.photo}
                      alt='Applicant Photo'
                      style={{ width: '200px', height: '200px' }}
                      className='rounded my-2'
                    />
                  </div>
                  <div className=' p-1'>
                    <h3 className='sub-heading__pinfo mb-2'><span className='stage_header'>Personal Information</span></h3>
                  </div>
                  <div className='row row-cols-lg-3 row-cols-md-2 p-1 px-4 row-cols-2'>
                    <div className='review-row col'>
                      <span className='review-label'>Surname: </span>
                      <span className='review-value' style={{ textTransform: 'capitalize' }}>
                         {(previewData.dataset.formData.surName || previewData.dataset.formData.surname)}
                      </span>
                    </div>
                    <div className='review-row col'>
                      <span className='review-label'>Firstname:</span>
                      <span className='review-value' style={{ textTransform: 'capitalize' }}>
                        {(previewData.dataset.formData.firstName || previewData.dataset.formData.firstname)}
                      </span>
                    </div>
                    <div className='review-row col'>
                      <span className='review-label'>Middle Name: </span>
                      <span className='review-value' style={{ textTransform: 'capitalize' }}>
                        {(previewData.dataset.formData.middleName || previewData.dataset.formData.middlename)}
                      </span>
                    </div>
                    <div className='review-row col'>
                      <span className='review-label'>NIN:</span>
                      <span className='review-value'>
                        {previewData.dataset.formData.nin}
                      </span>
                    </div>
                    <div className='review-row col'>
                      <span className='review-label'>Gender: </span>
                      <span className='review-value'>
                        {previewData.dataset.formData.gender === 'f' ? 'female' : 'male'}
                      </span>
                    </div>
                    <div className='review-row col'>
                      <span className='review-label'>Phone Number1: </span>
                      <span className='review-value'>
                        {previewData.dataset.formData.phone}
                      </span>
                    </div>
                    {previewData.dataset.formData.phon2 && <div className='review-row col'>
                      <span className='review-label'>Phone Number2: </span>
                      <span className='review-value'>
                        {previewData.dataset.formData.phone2}
                      </span>
                    </div>}
                    <div className='review-row col'>
                      <span className='review-label'>Email: </span>
                      <span className='review-value'>
                        {previewData.dataset.formData.email}
                      </span>
                    </div>
                    <div className='review-row col'>
                      <span className='review-label'>Marital Status: </span>
                      <span className='review-value'>
                        {previewData.dataset.formData.maritalStatus}
                      </span>
                    </div>
                    <div className='review-row col'>
                      <span className='review-label'>Date of Birth: </span>
                      <span className='review-value'>
                        {previewData.dataset.formData.dob}
                      </span>
                    </div>
                    <div className='review-row col'>
                      <span className='review-label'>Age: </span>
                      <span className='review-value'>
                        {previewData.dataset.formData.age}
                      </span>
                    </div>
                    <div className='review-row col'>
                      <span className='review-label'>Height: </span>
                      <span className='review-value'>
                        {previewData.dataset.formData.height} meters
                      </span>
                    </div>
                  </div>
                  <div className='p-1'>
                    <div className='mt-4'>
                      <h3 className='sub-heading__pinfo '>
                        State of Origin / Permanent Home Address
                      </h3>
                    </div>
                    <div className='row row-cols-lg-3 row-cols-md-2 p-1 px-4 row-cols-2'>
                      <div className='review-row col'>
                        <span className='review-label'>Nationality: </span>
                        <span className='review-value'>
                          {previewData.dataset.nimc.birthCountry}
                        </span>
                      </div>
                      <div className='review-row col'>
                        <span className='review-label'>State: </span>
                        <span className='review-value'>
                          {previewData.dataset.formData.stateOfPermanent}
                        </span>
                      </div>
                      <div className='review-row col'>
                        <span className='review-label'>LGA: </span>
                        <span className='review-value'>
                          {previewData.dataset.formData.lgaOfPermanent}
                        </span>
                      </div>
                      <div className='review-row col'>
                        <span className='review-label'>Street: </span>
                        <span className='review-value'>
                          {
                            previewData.dataset.formData
                              .streetAddressOfPermanent
                          }
                        </span>
                      </div>
                      <div className='review-row col'>
                        <span className='review-label'>Contact Phone: </span>
                        <span className='review-value'>
                          {previewData.dataset.formData.contactPhone}
                        </span>
                      </div>
                      <div className='review-row col'>
                        <span className='review-label'>Postal Address: </span>
                        <span className='review-value'>
                          {previewData.dataset.formData.postalAddress}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className='p-1'>
                    <div>
                      <h3 className='sub-heading__pinfo '>
                        Current Residential Address
                      </h3>
                    </div>

                    <div>
                      <div className='row row-cols-lg-3 row-cols-md-2 p-1 px-4 row-cols-2'>
                        <div className='review-row col'>
                          <span className='review-label'>
                            State of Residence:{' '}
                          </span>
                          <span className='review-value'>
                            {previewData.dataset.formData.stateOfResidence}
                          </span>
                        </div>
                          <div className='review-row col'>
                          <span className='review-label'>
                            LGA of Residence:{' '}
                          </span>
                          <span className='review-value'>
                            {previewData.dataset.formData.lgaOfResidence}
                          </span>
                        </div>
                         <div className='review-row col'>
                          <span className='review-label'>
                            Street of Residence:{' '}
                          </span>
                          <span className='review-value'>
                            {previewData.dataset.formData.streetAddressOfResidence}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                   <div className='p-1'>
                    <div>
                      <h3 className='sub-heading__pinfo '>
                       Next of kin
                      </h3>
                    </div>
                     <div className='row row-cols-lg-3 row-cols-md-2 p-1 px-4 row-cols-2'>
                           <div className='review-row col'>
                          <span className='review-label'>
                            Name:{' '}
                          </span>
                          <span className='review-value'>
                            {previewData.dataset.formData.nextOfKinName}
                          </span>
                        </div>
                        <div className='review-row col'>
                          <span className='review-label'>
                            Phone:{' '}
                          </span>
                          <span className='review-value'>
                            {previewData.dataset.formData.nextOfKinPhone}
                          </span>
                        </div>
                        <div className='review-row col'>
                          <span className='review-label'>
                            Email:{' '}
                          </span>
                          <span className='review-value'>
                            {previewData.dataset.formData.nextOfKinEmail}
                          </span>
                        </div>
                        <div className='review-row col'>
                          <span className='review-label'>
                            Gender:{' '}
                          </span>
                          <span className='review-value'>
                            {previewData.dataset.formData.nextOfKinGender}
                          </span>
                        </div>
                        <div className='review-row col'>
                          <span className='review-label'>
                            Relationship:{' '}
                          </span>
                          <span className='review-value'>
                            {previewData.dataset.formData.nextOfKinRelationship}
                          </span>
                        </div>
                     </div>
                    </div>
                    <ReviewALLDocument previewData={previewData} finalSubmissionForm={props?.finalSubmissionForm} finalSubmissionLoad={props.finalSubmissionLoad} setCurrentPage={props.setCurrentPage} currentPage={props.currentPage}/>
                        <div className='my-4'>
        <div className='alert alert-danger text-danger my-2'><b>!!! Kindly review all submitted documents and information carefully before final submission.</b> </div>

        <div className='d-flex justify-content-between '>
            <div>
                <button className='btn btn-outline-secondary' type='button' onClick={() => props.setCurrentPage(props.currentPage - 1)}>Previous page</button>
            </div>
            <div>
                <button className='btn btn-danger fw-bold ' type='button' onClick={async () => { await props.finalSubmissionForm(); }}><small>autosubmit({timeLeft})</small> <b>Final Submission</b></button>
            </div>
        </div>
    </div>
                </>
                  )
                : (
                <>
                  Unable to load preview data. Please ensure your NIN is correct
                  and try again.
                </>
                  )}
              {/* Additional review details and components can be added here */}
            </div>
          </div>
        </div>
      </section>
      {/* <Modal> */}
<Modal
  // {...props}
  show={props.submissionStatus}
  aria-labelledby="contained-modal-title-vcenter"
  centered // Makes the modal appear in the exact center of the screen
>
  {/* Header with just the close button (no text needed since the icon explains it) */}
  <Modal.Header closeButton className="border-0">
  </Modal.Header>

  <Modal.Body className="text-center pb-5">
    {/* FontAwesome v4 Icon */}
    <div className="mb-4">
      {timeLeft === 0 && <h1 className='text-danger my-4'>Application Submission Timed out</h1>}
      <i
        className="fa fa-check-circle text-success"
        style={{ fontSize: '5rem' }}
        aria-hidden="true"
      ></i>
    </div>
    {/* Success Text */}
    <h3 className="text-success font-weight-bold">Submission Successful</h3>
    <p className="text-muted">
      Your recruitment application has been received.
    </p>
    <p className="text-muted">
      <em>redirecting to print submission slip</em>
    </p>
    {/* Optional: Add a button to close or continue */}
    {/* <button
      onClick={props.onHide}
      className="btn btn-success px-4 mt-3"
      style={{ borderRadius: '20px' }}
    >
      Continue
    </button> */}
  </Modal.Body>
</Modal>

<Modal
  // {...props}
  show={showAttention}
  aria-labelledby="contained-modal-title-vcenter"
  centered
>
  {/* Header with close button */}
  <Modal.Header closeButton className="border-0">
  </Modal.Header>

  <Modal.Body className="text-center pb-5">
    {/* FontAwesome v4 Icon: Exclamation Triangle */}
    <div className="mb-4">
      <i
        className="fa fa-exclamation-triangle text-warning"
        style={{ fontSize: '5rem' }}
        aria-hidden="true"
      ></i>
    </div>

    {/* Warning Text */}
    <h3 className="text-warning font-weight-bold">Attention Required</h3>

    <p className="lead font-weight-bold">
      This is NOT the final submission.
    </p>

{/* Main Instruction */}
    <p className="lead mt-3">
      Please click the <strong>Final Submission</strong> button to complete your application,
      or wait <strong>3mins (180 secs)</strong> for the system to submit automatically.
    </p>

    {/* CRITICAL WARNING */}
    <div className="alert alert-danger font-weight-bold mt-4" role="alert">
      <i className="fa fa-ban mr-2"></i>
      DO NOT REFRESH OR CLOSE THIS PAGE.
    </div>

    {/* Optional Timer Display (if you implemented the timer from earlier) */}
    <p className="text-muted small">Auto-submitting in {timeLeft}s...</p>
  </Modal.Body>
</Modal>
    </div>
  );
}
